import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useEditorData, useFabricEditor } from '../../lib/FabricJs';
import TextToolbar from './TextToolbar';
import { editorTheme, TOOLBAR_HEIGHT } from '../../theme';

const ToolBarContainer = styled.div`
  background: ${editorTheme.surface};
  display: flex;
  flex: none;
  height: ${TOOLBAR_HEIGHT}px;
  padding: 0 10px;
  gap: 8px;
  border-bottom: 1px solid ${editorTheme.border};
  align-items: center;
  justify-content: space-between;
`;

// Scrolls sideways when the window is too narrow for every control.
const Left = styled.div`
  align-items: center;
  display: flex;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: thin;
`;

const Hint = styled.span`
  font-size: 13px;
  color: ${editorTheme.textMuted};
  padding: 0 6px;
`;

const KvsView = styled.span`
  font-size: 12px;
  font-family: monospace;
  color: ${editorTheme.accentHover};
  background: ${editorTheme.accentSoft};
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
`;

const ToolBar: FC = () => {
  const { selectMode } = useEditorData();
  const { canvas } = useFabricEditor();
  const [kvsKey, setKvsKey] = useState(null);

  useEffect(() => {
    const activeObjects = canvas?.getActiveObjects();
    if (activeObjects?.length === 1) {
      const [activeObject] = activeObjects;
      if (activeObject?.data?.type === 'kvs') {
        setKvsKey(activeObject?.data?.kvsKey);
      } else {
        setKvsKey(null);
      }
    } else {
      setKvsKey(null);
    }
  }, [canvas?.getActiveObjects()]);

  return (
    <ToolBarContainer role="toolbar" aria-label="Formatting">
      <Left>
        {!selectMode && <Hint>Select an object on the slide to edit it</Hint>}
        <TextToolbar />
      </Left>
      {kvsKey && <KvsView>KVS · {kvsKey}</KvsView>}
    </ToolBarContainer>
  );
};

export default ToolBar;
